import {
  Injectable,
  ViewMetadata,
  ComponentMetadata,
} from '@angular/core';

import {ReflectorReader, reflector} from '../core_private';

import {Type, stringify, isBlank, isPresent} from '../src/facade/lang';
import {BaseException} from '../src/facade/exceptions';
import {Map} from '../src/facade/collection';
export class ViewResolver {
  private _reflector: ReflectorReader;

  /** @internal */
  _cache = new Map<Type, ViewMetadata>();

  constructor(_reflector?: ReflectorReader) {
    if (isPresent(_reflector)) {
      this._reflector = _reflector;
    } else {
      this._reflector = reflector;
    }
  }

  resolve(component: Type): ViewMetadata {
    var view = this._cache.get(component);

    if (isBlank(view)) {
      view = this._resolve(component);
      this._cache.set(component, view);
    }

    return view;
  }

  /** @internal */
  _resolve(component: Type): ViewMetadata {
    var compMeta: ComponentMetadata;

    this._reflector.annotations(component).forEach(m => {
      if (m instanceof ComponentMetadata) {
        compMeta = m;
      }
    });

    if (isPresent(compMeta)) {
      if (isBlank(compMeta.template) && isBlank(compMeta.templateUrl)) {
        throw new BaseException(
            `Component '${stringify(component)}' must have either 'template' or 'templateUrl' set.`);

      } else {
        return new ViewMetadata({
          templateUrl: compMeta.templateUrl,
          template: compMeta.template,
          directives: compMeta.directives,
          pipes: compMeta.pipes,
          encapsulation: compMeta.encapsulation,
          styles: compMeta.styles,
          styleUrls: compMeta.styleUrls,
          animations: compMeta.animations
        });
      }
    } else {
        throw new BaseException(
            `Could not compile '${stringify(component)}' because it is not a component.`);
    }
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
{type: ReflectorReader, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
